import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store' // для хука beforeEach, beforeEnter или beforeRouteEnter

import ServerIsNotAvailable from '@/components/CommonPages/ServerIsNotAvailable'
import PageNotFound from '@/components/CommonPages/404PageNotFound'

import Welcome from '@/components/Welcome/Welcome'
import SignIn from '@/components/Welcome/SignIn'
import SignUp from '@/components/Welcome/SignUp'
import ForgotPassword from '@/components/Welcome/ForgotPassword'

import MainLayout from '@/components/MainLayout'

import MainDashboard from '@/components/MainDashboard'
import News from '@/components/News'
import UserProfile from '@/components/UserProfile'

import TasksMain from '@/components/Tasks/Main'
import TaskBoards from '@/components/Tasks/TaskBoards'
import TaskBoardSettings from '@/components/Tasks/TaskBoardSettings'
import TaskEdit from '@/components/Tasks/TaskEdit'

import Partners from '@/components/Partners/Partners'
import FinixTasks from '@/components/FinixTasks/FinixTasks'
import FinixTasksReport from '@/components/FinixTasks/FinixTasksReport'

import AdminPanelNews from '@/components/AdminPanel/News'
import AdminPanelFinixBanks from '@/components/AdminPanel/FinixBanks'
import AdminPanelUsers from '@/components/AdminPanel/Users'

import http from 'axios'

// const SearchResults = resolve => {
  // require.ensure(['@/components/Main/SearchResults'], () => {
    // resolve(require('@/components/Main/SearchResults'))
  // }, 'pack1')
// }

// component: (resolve) => require(['./views/index.vue'], resolve)
// const SearchResults = resolve => {
//   require(['@/components/Main/SearchResults'], resolve)
// }

Vue.use(Router)

const router = new Router({
  mode: 'history', // 'history' mode - don't see a hash '#' in urls
  routes: [
    // ////////////////////////////////////////////////////////////////////////////////////////////////////

    {
      path: '/serverisnotavailable',
      component: ServerIsNotAvailable
    },

    // ////////////////////////////////////////////////////////////////////////////////////////////////////

    {
      path: '/welcome',
      component: Welcome,
      beforeEnter (to, from, next) {
        // если уже авторизованы то идем в основное меню
        if (store.getters.activeUser !== null) {
          next('/')
        } else {
          next()
        }
      },
      children: [
        {
          path: '',
          component: SignIn
        },
        {
          path: 'signup',
          component: SignUp
        },
        {
          path: 'forgotpassword',
          component: ForgotPassword
        }
      ]
    },

    // ////////////////////////////////////////////////////////////////////////////////////////////////////

    {
      path: '/adminPanel',
      component: MainLayout,
      beforeEnter (to, from, next) {
        // в MainLayout можно попасть только если авторизован
        if (store.getters.activeUser === null) {
          store.commit('appStateLastWorkingRouteSet', to.path)
          next('/welcome')
        } else {
          next()
        }
      },
      children: [
        /* {
          path: '',
          component: AdminDashboard
        }, */
        {
          path: 'news',
          component: AdminPanelNews
        },
        {
          path: 'users',
          component: AdminPanelUsers
        },
        {
          path: 'finixBanks',
          component: AdminPanelFinixBanks
        },
        {
          path: '*',
          component: PageNotFound
        }
      ]
    },

    // ////////////////////////////////////////////////////////////////////////////////////////////////////

    {
      path: '/',
      component: MainLayout,
      beforeEnter (to, from, next) {
        // в MainLayout можно попасть только если авторизован
        if (store.getters.activeUser === null) {
          store.commit('appStateLastWorkingRouteSet', to.path)
          next('/welcome')
        } else {
          next()
        }
      },
      children: [
        {
          path: '',
          component: MainDashboard
        },
        {
          path: 'profile',
          component: UserProfile
        },
        {
          path: 'news',
          component: News
        },
        {
          path: 'finixOrders',
          component: FinixTasks
        },
        {
          path: 'finixOrdersReport',
          component: FinixTasksReport
        },
        {
          path: 'tasks',
          component: TasksMain,
          children: [
            {
              path: '',
              component: TaskBoards
            },
            {
              path: 'taskBoardSettings',
              component: TaskBoardSettings
            },
            {
              path: 'taskEdit',
              component: TaskEdit
            }
          ]
        },
        {
          path: 'partners',
          component: Partners
        },
        {
          path: '*',
          component: PageNotFound
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = store.getters.appSettings.appName

  // если host db еще не выбрана то давайте отобразим welcome чтобы выбрать
  if (store.getters.appSettings.server.host == null) {
    let host = localStorage.getItem('BMSClientHost')
    if (host != null) {
      store.commit('serverHostSet', host)
    } else if (to.path === '/serverisnotavailable') {
      return next('/welcome')
    }
  }

  // для начала вообще по любому роуту можно пройти только если есть связь с сервером
  if ((store.getters.appSettings.server.host != null) && (store.getters.appState.serverConnected === false) && (to.path !== '/serverisnotavailable')) {
    if (store.getters.lastWorkingRoute !== null) store.commit('appStateLastWorkingRouteSet', to.path)
    return next('/serverisnotavailable')
  }
  // если идем на '/serverisnotavailable' то никакие запросы к серверу не делаем и сразу идем туда
  if (to.path === '/serverisnotavailable') {
    return next()
  }
  // если пользователь установлен то сразу заканчиваем работу
  if (store.getters.activeUser !== null) {
    return next()
  }
  if (store.getters.appSettings.server.host == null) {
    return next()
  }
  // иначе устанавливаем пользователя в приложении, беря его с сервера
  http.get(store.getters.appSettings.server.host + store.getters.appSettings.server.userGetActiveUser) // вызов вовзращает с сервера activeUser object ИЛИ 403 (Forbidden)
  .then(function (response) {
    // let BMSClient2017ActiveUser = JSON.parse(localStorage.BMSClient2017ActiveUser)
    // localStorage.setItem('BMSClient2017ActiveUser', JSON.stringify(response.data)) // перезаписываем localStorage на случай если на сервере изменились детали activeUser
    store.commit('activeUserSet', response.data)
    // TODO: проверка пермишенов
    return next()
  })
  .catch(function (error) {
    // если сервер вернул 403 значит пользователь не залогинен
    if ((error.response != null) && (error.response.status === 403)) {
      // ничего не делаем, специфика каждого роутера сама разберется что делать если пользователь все так же не установлен
      return next()
    } else {
      if (store.getters.lastWorkingRoute !== null) store.commit('appStateLastWorkingRouteSet', to.path)
      store.commit('appStateServerConnectedSet', false)
      return next('/serverisnotavailable')
    }
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js